import { initialState } from "./state"

export default {
  setOrigin: (state, payload) => (state.origin = payload),
  setOrderUuid: (state, payload) => (state.orderUuid = payload),
  setLoading: (state, payload) => (state.loading = payload),
  setRules: (state, payload) => (state.rules = payload),
  updateIndexStepsAlreadyVisited: (state, payload) =>
    (state.indexStepsAlreadyVisited = payload),
  updatePreviousRoute: (state, payload) => (state.previousRoute = payload),
  resetCore: state => {
    const INITIAL_STATE = initialState()
    Object.keys(state).forEach(key => {
      state[key] = INITIAL_STATE[key]
    })
  },
  setCoverageStatus: (state, payload) => (state.coverageStatus = payload),
  setCustomerType: (state, payload) => (state.customerType = payload)
}
